import React from 'react';
import PropTypes from 'prop-types';

export default class HtmlContent extends React.Component {
  render() {
    const { content } = this.props;
    return (
      <div className="adventcount-content" dangerouslySetInnerHTML={{ __html: content }} />
    );
  }
}

HtmlContent.propTypes = {
  content: PropTypes.string.isRequired,
};
